import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export interface IRegisterActionInfoModel extends IRestModel {
    name: string;
    hasParameters: boolean;
    parametersDescription: string;
    parametersDefaults: string;
    parametersPattern: string;
}

export class RegisterActionInfoModel extends BaseModel implements IRegisterActionInfoModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;

    public name: string = null;
    public hasParameters: boolean = null;
    public parametersDescription: string = null;
    public parametersDefaults: string = null;
    public parametersPattern: string = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-RegisterActionInfoModel');
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
        };
    }
}
